<template>
  <ElDescriptions :column="1">
    <ElDescriptionsItem label="宽度">
      <ElInputNumber
        :modelValue="weight"
        @update:modelValue="$emit('styleChange', 'weight', $event)"
        :min="1"
        size="small"
      />
    </ElDescriptionsItem>
    <ElDescriptionsItem label="样式">
      <ElSelect
        style="width: 12.5rem;"
        :modelValue="dashArray"
        @update:modelValue="$emit('styleChange', 'dashArray', $event)"
        size="small"
        :options="dashOptions"
      />
    </ElDescriptionsItem>
    <ElDescriptionsItem label="颜色">
      <ElColorPicker
        :modelValue="fill"
        @update:modelValue="$emit('styleChange', 'color', $event)"
      />
    </ElDescriptionsItem>
  </ElDescriptions>
</template>

<script setup>
import {
  ElDescriptions, ElDescriptionsItem, ElInputNumber,
  ElSelect, ElColorPicker,
} from 'element-plus';

defineProps({
  weight: { type: Number, default: 1 },
  dashArray: { type: String, default: '0' },
  fill: { type: String, default: '' },
});

defineEmits(['styleChange']);

const dashOptions = [
  { label: '实线', value: '0' },
  { label: '虚线', value: '5,5' },
  { label: '点线', value: '1,5' },
];
</script>
